import Grid from '@material-ui/core/Grid';
import { UserSettingsProfileCard } from '@backstage/plugin-user-settings';
// import { UserSettingsAppearanceCard } from './CustomUserSettingsAppearanceCard';
import React from 'react';

/** @public */
export const UserSettingsGeneral = () => {
  return (
    <Grid container direction="row" spacing={3}>
      <Grid item xs={12}>
        <UserSettingsProfileCard />
      </Grid>
      {/* <Grid item xs={12} md={6}>
        <UserSettingsAppearanceCard />
      </Grid> */}
      {/* <Grid item xs={12} md={6}>
<UserSettingsIdentityCard />
</Grid> */}
    </Grid>
  );
};
